import {
  bluePaletteDark,
  grayPaletteDark,
  greenPaletteDark,
  redPaletteDark,
  yellowPaletteDark,
} from '../../themes/dark-colors';

export const highlightDarkTheme = {
  variants: {
    success: {
      backgroundColor: greenPaletteDark[200],
      iconColor: greenPaletteDark[500],
    },
    warning: {
      backgroundColor: yellowPaletteDark[300],
      iconColor: yellowPaletteDark[800],
    },
    danger: {
      backgroundColor: redPaletteDark[200],
      iconColor: redPaletteDark[600],
    },
    announcement: {
      backgroundColor: bluePaletteDark[200],
      iconColor: bluePaletteDark[800],
    },
    info: {
      backgroundColor: grayPaletteDark[300],
      iconColor: grayPaletteDark[800],
    },
  },
};
